export default __webpack_public_path__ + "static/media/logo192x192.2bfcb896.png";